(() => {
  const syncRecommendationsState = (recommendations) => {
    const panel = recommendations.closest('[data-recommendations-panel]');
    const drawer = recommendations.closest('cart-drawer');

    if (!panel || !drawer) {
      return;
    }

    const hasRecommendations = recommendations.innerHTML.trim().length > 0;

    panel.classList.toggle('cart-drawer-recommendations-panel--loaded', hasRecommendations);
    drawer.classList.toggle('cart-drawer--has-recommendations', hasRecommendations);
  };

  const bindRecommendationsPanel = (recommendations) => {
    if (recommendations.dataset.tecRecommendationsBound === 'true') {
      syncRecommendationsState(recommendations);
      return;
    }

    recommendations.dataset.tecRecommendationsBound = 'true';

    const observer = new MutationObserver(() => {
      syncRecommendationsState(recommendations);
    });

    observer.observe(recommendations, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    syncRecommendationsState(recommendations);
  };

  const bindAllRecommendationsPanels = (root = document) => {
    root.querySelectorAll('cart-drawer [data-recommendations-panel] product-recommendations').forEach(bindRecommendationsPanel);
  };

  document.addEventListener('DOMContentLoaded', () => {
    bindAllRecommendationsPanels();

    const rootObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.matches('cart-drawer [data-recommendations-panel] product-recommendations')) {
            bindRecommendationsPanel(node);
            return;
          }

          bindAllRecommendationsPanels(node);
        });
      });
    });

    rootObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
